import { damageLevelInfoGetRoundedStyle as infoGetRoundedStyle} from 'pages/NotifyEvent/constant_text'
import { IoCloseSharp } from 'react-icons/io5'
import { SUB_DAMAGE_LEVEL_LIST } from 'utils/subdamageEnum'

interface ISubDamageLevelInfoModal {
  close: () => void
  chooseSubDamageLevel: (id: string) => void
  chosenElementId: string
}
export default function SubDamageLevelInfoModal({ close, chooseSubDamageLevel, chosenElementId }: ISubDamageLevelInfoModal) {
  return (
    <div data-testid="test-dmg-lvl-modal" className="md:p-8 text-left  md:max-w-[1022px] ">
      <div className='flex'>
        <p className="text-xl font-semibold text-yellow">Subclassificação do Incidente com Dano</p>
        <div
          className='ml-auto cursor-pointer'
          data-testid="test-close-dmg-lvl-modal"
          onClick={close}
        >
          <IoCloseSharp
            className="text-blueTheme h-8 w-8 p-1 cursor-pointer "
          />
        </div>
      </div>
      <p className="text-darkGray text-xs">
        Confira abaixo o que cada subclassificação do Grau de dano do incidente significa:
      </p>
      <div className="mt-4">
        {SUB_DAMAGE_LEVEL_LIST.map((e, idx) => {
          const roundedStyle = infoGetRoundedStyle( idx, e.index);
          const isSelected = e.value === chosenElementId;
          
          return (
            <div
              key={e.value}
              onClick={() => chooseSubDamageLevel(e.value)}
              className={`
                hover:border-[#F0B323]
                border
                ${isSelected ? "bg-[#FFFCF3] border-[#F0B323]" : "border-[#EBEFF5]"}
                ${roundedStyle}
                flex md:flex-row flex-col
                justify-start
                px-2 md:px-6
                py-2
                md:items-center
                cursor-pointer
              `}
            >
              <div className="md:w-[15%] mr-10">
                <p className="text-blueTheme font-semibold text-sm md:text-base">
                  {e.title}
                </p>
              </div>

              <p className="text-darkGray md:text-sm w-full text-[10px]">
                {e.description}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  )
}
